import * as NewsService from '@/services/news';
import { find } from 'lodash';

export default {
  namespaced: true,

  state: {
    all: []
  },

  getters: {
    GET_NEWS_BY_ID: state => id => {
      return find(state.all, { id: id });
    }
  },

  mutations: {
    SET_NEWS(state, payload) {
      state.all = payload.news;
    }
  },

  actions: {
    GET_NEWS({ commit, state }, payload) {
      return NewsService.getNews()
        .then(response => {
          if (response.data) {
            commit('SET_NEWS', { news: response.data });
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    GET_NEWS_BY_ID({ commit, state }, payload) {
      return NewsService.getNewsById(payload.id)
        .then(response => {
          // if (response.data) {
          //     commit('SET_NEWS', { news: response.data });
          // }

          return response;
        })
        .catch(err => {
          return err;
        });
    }
  }
};
